<template>
<div>
  <label for="season"><strong>REPARTO</strong></label>
  <div v-if="props.type"  class="form-group">
    
    <select id='department' :required="props.required" :disabled="!props.isActive" @change="$emit('update',departmentId,$event)" class="form-control" v-model="departmentId">
      <option v-if="props.optionBase" value="0"> -- TUTTI I REPARTI -- </option>  
      <option v-for="(item,index) in items" :value="item.departmentId" :key="index">{{item.department}}</option>        
    </select>  
  </div>

  <div v-else v-for="(item,index) in items" :key="index" >
 
 
  <div class="form-check form-check-inline">
    <input @click="setDepartment(index)" type="checkbox" class="form-check-input" :id="'departmentCheck_' + index" :value="item.departmentId">
    <label class="form-check-label"  :for="'departmentCheck_' + index">{{item.department}}</label>
  </div>
      
  </div>  

</div>


</template>
<script>
import api             from "@/api";

export default {
  props : ['props'] , 
  components: {},
  data() {
    return {

      departmentId           : 0,
      items                  : [],
      selection              : [],
      spinner                : false
     
    };
  },
  mounted: function() {
  
  },
  created: function() {
      this.getData()
  },
  methods: 
  {
    setDepartment(index)
    {
      var arr = []
      if(this.selection.indexOf(this.items[index]['departmentId']) == -1)
      {
        this.selection.push(this.items[index]['departmentId'])

      }
      else
      {
        arr = this.selection.filter(item => item != this.items[index]['departmentId'])
        this.selection = arr
      }
      
      
      var temp = []
      if(this.selection.length==0)
      {
        temp = []
        this.items.forEach(
          item =>{
            temp.push(item.departmentId)
          }
        )
      }
      else
      {
        temp = this.selection
      }

      
      this.$emit('update',temp)

    },
    async getData()
    {
            
      var json   = {'sp'  : 'spDepartmentSelect'}    
      await api.post(json).then(res => {
          
       

          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
              this.departmentId = this.props.Id
            }
           else if(res.status==500)
           {
                console.log(res.data)
                                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });


    },
  
    
    
  
}

}
</script>
<style scoped>


select{
    _font-weight: bold;
    _color: blue;

}

.form-check-label{
  cursor:pointer
}
</style>